import axios from "axios";

export const readBackupNotification = (token) => {
  return axios.get("user/getTrialInfo", {
    headers: {
      "API-TOKEN": token,
    },
  });
};
